import ReducerGenerator from '../../lib/ReducerGenerator'

const generator = new ReducerGenerator('network', '/networks')
const reducer = generator.generate()

export default reducer
